import {
  Dialog,
  DialogButtons,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import { useAnalysisSaveModal } from '../hooks/useAnalysisSaveModal';
import type { AnalysisSaveModalProps } from '../types';
import { DIALOG_PAPER_SX } from './dialogPaperSx';

export const AnalysisSaveModal = ({ onClose }: AnalysisSaveModalProps) => {
  const {
    title,
    loadingTitle,
    loadingText,
    errorTitle,
    errorText,
    retryButtonLabel,
    isSubmitting,
    submittingError,
    onRetry,
  } = useAnalysisSaveModal({ onClose });

  // While the save round-trip is in flight there is no exit affordance — the
  // user shouldn't be able to dismiss the dialog mid-flight (the BE write
  // would still land but the UI would lose the success/navigation handoff).
  // The error state restores the close affordance so the user can give up.
  const inError = !!submittingError && !isSubmitting;

  return (
    <Dialog
      id="analysisSaveModal"
      open
      PaperProps={{ sx: DIALOG_PAPER_SX }}
      fullWidth
      maxWidth="lg"
      onClose={inError ? onClose : undefined}
    >
      <DialogTitle
        id="analysis-save-modal-title"
        showClose={inError}
        onClose={inError ? onClose : undefined}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {inError ? (
          <DialogMessageBox
            id="analysis-save-modal-error"
            title={errorTitle}
            type="error"
            text={errorText}
          />
        ) : (
          <DialogMessageBox
            id="analysis-save-modal-loading"
            title={loadingTitle}
            type="loading"
            text={loadingText}
          />
        )}
      </DialogContent>
      {inError && (
        <DialogButtons
          id="analysis-save-modal-buttons"
          saveButton={{ label: retryButtonLabel, onClick: onRetry }}
        />
      )}
    </Dialog>
  );
};
